let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("39J6G")).then(() => parcelRequire('2gc8v'));